(function(){
  const header=document.querySelector('.site-header');
  const onScroll=()=> header && header.classList.toggle('is-scrolled', window.scrollY>20);
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

  const io=new IntersectionObserver((entries)=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})}, {threshold:.14, rootMargin:'0px 0px -40px'});
  document.querySelectorAll('.reveal,.image-reveal').forEach(el=>io.observe(el));

  const drawer=document.querySelector('[data-drawer]');
  const overlay=document.querySelector('[data-overlay]');
  const openers=document.querySelectorAll('[data-open-drawer]');
  const closers=document.querySelectorAll('[data-close-drawer]');
  const setDrawer=(open)=>{ if(!drawer||!overlay)return; drawer.classList.toggle('is-open',open); overlay.classList.toggle('is-open',open); document.documentElement.style.overflow=open?'hidden':''; };
  openers.forEach(b=>b.addEventListener('click',()=>setDrawer(true)));
  closers.forEach(b=>b.addEventListener('click',()=>setDrawer(false)));
  overlay&&overlay.addEventListener('click',()=>setDrawer(false));

  const filterDrawer=document.querySelector('[data-filter-drawer]');
  const filterOpen=document.querySelector('[data-open-filter]');
  const filterClose=document.querySelector('[data-close-filter]');
  const filterOverlay=document.querySelector('[data-filter-overlay]');
  const setFilter=(open)=>{ if(!filterDrawer||!filterOverlay)return; filterDrawer.classList.toggle('is-open',open); filterOverlay.classList.toggle('is-open',open); document.documentElement.style.overflow=open?'hidden':''; };
  filterOpen&&filterOpen.addEventListener('click',()=>setFilter(true));
  filterClose&&filterClose.addEventListener('click',()=>setFilter(false));
  filterOverlay&&filterOverlay.addEventListener('click',()=>setFilter(false));
})();
